var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,_vm._b({tag:"component",staticClass:"mdc-list",class:_vm.classes,attrs:{"tabindex":"0"}},'component',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }